export default __webpack_public_path__ + "125fbb9b08fd587dbb76c195c6cbb0bf.png";